export class Configurations {
    public static readonly globalGroup: string = 'Global';

    public static readonly crewPortalGroup: string = 'CrewPortal';
    public static readonly crewPortalChangelogPageRules: string = 'ChangelogPageRules';
    public static readonly crewPortalPersonFreelancePageRulesCockpit: string = 'PersonFreelancePageRulesCockpit';
    public static readonly crewPortalPersonFreelancePageRulesCabin: string = 'PersonFreelancePageRulesCabin';
    public static readonly crewPortalLtoPageRulesCabin: string = 'LtoPageRulesCabin';
    public static readonly crewPortalLtoPageRulesCockpit: string = 'LtoPageRulesCockpit';
    public static readonly crewPortalStoPageRulesCabin: string = 'StoPageRulesCabin';
    public static readonly crewPortalStoPageRulesCockpit: string = 'StoPageRulesCockpit';
    public static readonly crewPortalFlightPageRulesCabin: string = 'FlightPageRulesCabin';
    public static readonly crewPortalFlightPageRulesCockpit: string = 'FlightPageRulesCockpit';
    public static readonly crewPortalPersonNbuPageRules: string = 'PersonNbuPageRules';
    public static readonly crewPortalVacationPageRulesCabin: string = 'VacationPageRulesCabin';
    public static readonly crewPortalVacationPageRulesCockpit: string = 'VacationPageRulesCockpit';
    public static readonly crewPortalReservePageRulesCockpit: string = 'ReservePageRulesCockpit';

    public static readonly featureGroup: string = 'Feature';
    public static readonly featureEnableShowAllErrorCategories: string = 'EnableShowAllErrorCategories';
    public static readonly featureEnableChangeLogPushNotification: string = 'EnableChangeLogPushNotification';
    public static readonly featureEnableTzvCockpit: string = 'EnableTZVCockpit';
    public static readonly featureEnableTzvCabin: string = 'EnableTZVCabin';
    public static readonly featureEnableExperienceReport: string = 'EnableExperienceReport';
    public static readonly featureEnableLTECabin: string = 'EnableLTECabin';
    public static readonly featureEnableLogbook: string = 'EnableLogbook';
    public static readonly featureEnableTakeOffRecencyOnCrewPortal: string = 'EnableTakeOffRecencyOnCrewPortal';
    public static readonly featureEnableCabinAttestation: string = 'EnableCabinAttestation';
    public static readonly featureEnableSimOverview: string = 'EnableSimOverview';
    public static readonly featureEnableSimCourseOverview: string = 'EnableSimCourseOverview';
    public static readonly featureEnableEfaUi: string = 'EnableEfaExportUi';
    public static readonly featureEnableEBT: string = 'EnableEBT';
    public static readonly featureEnableReserveTool: string = 'EnableReserveTool';
    public static readonly featureEnableCabinReserveTool: string = 'EnableCabinReserveTool';
    public static readonly featureEnableAiExplanation: string = 'EnableAzureAiValidationExplanation';

    public static readonly ebtGroup:string = 'EBT';
    public static readonly ebtFromDate: string = 'EBTFromDate';

    public static readonly validationGroup: string = 'Validation';
    public static readonly validationXStarManualTagEffectiveFromDate: string = 'XStarManualTagEffectiveFromDate';
    public static readonly gavCockpit2024DoooFromDate = 'GavCockpit2024DoooFromDate';  
    public static readonly gavCockpit2024JulyEffectiveDate = 'GavCockpit2024JulyEffectiveDate';
    public static readonly gavCockpit2024JuneEffectiveDate = 'GavCockpit2024JuneEffectiveDate';
    public static readonly gavCockpit2024MayEffectiveDate = 'GavCockpit2024MayEffectiveDate';

    public static readonly featureVacUbuKey: string = 'U-VAC/U-UBU';
    public static readonly cabinCockpitFlagsEnableKey: string = 'CabinCockpitFlagsEnable';
    public static readonly recencyTimelinePopup: string = 'RecencyTimelinePopup';
    public static readonly enableEasaWarning: string = 'EnableEasaWarning';
    public static readonly featureKeys: string[] = [Configurations.featureVacUbuKey, Configurations.cabinCockpitFlagsEnableKey, Configurations.recencyTimelinePopup, Configurations.enableEasaWarning];

    public static readonly helpLinkKey: string = 'HelpLink';
    public static readonly requestToolGroup: string = 'RequestTool';
    public static readonly allowEditStoInDateRangeAsLto: string = 'AllowEditStoInDateRangeAsLto';
    public static readonly hideVacToolLinkFor: string = 'HideVacToolLinkFor';
    public static readonly enablePWA: string = 'EnablePWA';

    public static readonly pushNotificationTag_ChangeLog: string = 'ChangeLog';

    public static readonly gav24JulyEffectiveDate = 'GavCockpit2024JulyEffectiveDate';
    public static readonly planningAutomation = 'PlanningAutomation';
}
